/* BulgarianScents theme JS */
(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = (window.BS && BS.moneyFormat) || '€{{amount_with_comma_separator}}';
    const value = (n, dec, thou, decSep) => {
      n = (Number(n) / 100).toFixed(dec);
      const parts = n.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(decSep);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return value(cents, 2, ',', '.');
        case 'amount_no_decimals': return value(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return value(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return value(cents, 0, '.', ',');
        case 'amount_with_space_separator': return value(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return value(cents, 2, ' ', '.');
        default: return value(cents, 2, ' ', ',');
      }
    });
  }
  window.BSformatMoney = formatMoney;

  /* ---------- Toast ---------- */
  let toastT;
  function toast(msg) {
    const t = $('#Toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('is-visible'), 2600);
  }

  /* ---------- Header scroll state ---------- */
  const hw = $('.header-wrap');
  if (hw) {
    const onScroll = () => hw.classList.toggle('is-scrolled', window.scrollY > 30);
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Drawers ---------- */
  function openDrawer(id) {
    const d = document.getElementById(id); if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const f = d.querySelector('button, a, input'); if (f) setTimeout(() => f.focus(), 300);
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(d => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    $$('.search-overlay.is-open').forEach(d => d.classList.remove('is-open'));
    document.body.style.overflow = '';
  }
  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      const id = opener.dataset.open;
      if (id === 'Search') { const s = $('#SearchOverlay'); s.classList.add('is-open'); setTimeout(() => $('input', s).focus(), 50); return; }
      openDrawer(id); return;
    }
    if (e.target.closest('[data-close]')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    const observe = () => $$('[data-reveal]:not(.is-in), [data-clip]:not(.is-in)').forEach(el => io.observe(el));
    observe();
    document.addEventListener('shopify:section:load', observe);
  } else { $$('[data-reveal], [data-clip]').forEach(el => el.classList.add('is-in')); }

  /* ---------- Cart ---------- */
  async function refreshCartDrawer(open) {
    try {
      const res = await fetch(BS.routes.root.replace(/\/$/, '') + '/?sections=cart-drawer');
      const data = await res.json();
      const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const fresh = html.querySelector('#CartDrawer');
      const cur = $('#CartDrawer');
      if (fresh && cur) {
        cur.querySelector('.drawer__panel').innerHTML = fresh.querySelector('.drawer__panel').innerHTML;
      }
      const cart = await (await fetch(BS.routes.cart + '.js')).json();
      $$('.cart-count').forEach(c => { c.textContent = cart.item_count; c.dataset.count = cart.item_count; });
      if (open) openDrawer('CartDrawer');
    } catch (err) { window.location.href = BS.routes.cart; }
  }

  async function addToCart(form, btn) {
    btn && btn.classList.add('is-loading');
    try {
      const res = await fetch(BS.routes.cart_add + '.js', {
        method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
      });
      const json = await res.json();
      if (!res.ok) { toast(json.description || json.message || BS.strings.error); return; }
      document.dispatchEvent(new CustomEvent('bs:added', { detail: { form } }));
      const wait = (window.BSMotion && BSMotion.flyDuration) || 0;
      if (wait) await new Promise(r => setTimeout(r, wait));
      toast(BS.strings.added);
      await refreshCartDrawer(true);
    } catch (err) { form.submit(); }
    finally { btn && btn.classList.remove('is-loading'); }
  }

  document.addEventListener('submit', e => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form || form.dataset.noAjax !== undefined) return;
    e.preventDefault();
    addToCart(form, form.querySelector('[type=submit]'));
  });

  async function changeLine(line, quantity) {
    const drawer = $('#CartDrawer .drawer__panel');
    drawer && (drawer.style.opacity = '.6');
    try {
      const res = await fetch(BS.routes.cart_change + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      if (!res.ok) { const j = await res.json(); toast(j.description || BS.strings.error); }
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
      await refreshCartDrawer(false);
    } finally { drawer && (drawer.style.opacity = ''); }
  }
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-line-change]');
    if (b) {
      e.preventDefault();
      changeLine(Number(b.dataset.line), Number(b.dataset.qty));
    }
  });

  /* ---------- Qty widgets (product page) ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    const v = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.dataset.qtyStep));
    input.value = v;
  });

  /* ---------- Product variants ---------- */
  $$('[data-product]').forEach(root => {
    const json = $('script[type="application/json"][data-variants]', root);
    if (!json) return;
    const variants = JSON.parse(json.textContent);
    const idInput = $('input[name="id"]', root);
    const priceEl = $('[data-price]', root);
    const btn = $('[data-atc]', root);
    const stickyPrice = $('[data-sticky-price]');
    const stickyBtn = $('[data-sticky-atc]');

    function selected() {
      return $$('fieldset[data-option]', root).map(fs => {
        const c = $('input:checked', fs); return c ? c.value : null;
      });
    }
    function update() {
      const opts = selected();
      const v = variants.find(v => v.options.every((o, i) => o === opts[i]));
      // availability marks
      $$('fieldset[data-option]', root).forEach((fs, idx) => {
        $$('input', fs).forEach(inp => {
          const test = opts.slice(); test[idx] = inp.value;
          const ok = variants.some(v => v.available && v.options.every((o, i) => o === test[i]));
          inp.classList.toggle('is-unavailable', !ok);
        });
      });
      if (!v) { btn.disabled = true; return; }
      idInput.value = v.id;
      let html = '<span class="price__now">' + formatMoney(v.price) + '</span>';
      if (v.compare_at_price > v.price) html += '<s>' + formatMoney(v.compare_at_price) + '</s>';
      priceEl.innerHTML = '<div class="price' + (v.compare_at_price > v.price ? ' price--sale' : '') + '">' + html + '</div>';
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      btn.disabled = !v.available;
      btn.textContent = v.available ? BS.strings.addToCart : BS.strings.soldOut;
      if (stickyBtn) { stickyBtn.disabled = !v.available; }
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      if (v.featured_media) {
        const m = root.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (m && window.innerWidth < 900) m.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }
    root.addEventListener('change', e => { if (e.target.closest('fieldset[data-option]')) update(); });
    update();

    // Sticky ATC
    const sticky = $('.sticky-atc');
    if (sticky && btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(btn);
      stickyBtn && stickyBtn.addEventListener('click', () => btn.click());
    }
  });

  /* ---------- Collection: sort + filters ---------- */
  const sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', () => {
    const url = new URL(window.location.href); url.searchParams.set('sort_by', sort.value); url.searchParams.delete('page');
    window.location.href = url.toString();
  });
  const filterForm = $('[data-filter-form]');
  if (filterForm) filterForm.addEventListener('change', () => {
    const params = new URLSearchParams(new FormData(filterForm));
    const s = new URL(window.location.href).searchParams.get('sort_by');
    if (s) params.set('sort_by', s);
    window.location.search = params.toString();
  });

  /* ---------- Scent finder ---------- */
  $$('[data-finder]').forEach(f => {
    const steps = $$('.finder__step', f);
    const bars = $$('.finder__progress i', f);
    const tags = [];
    let i = 0;
    const show = n => { steps.forEach((s, k) => s.classList.toggle('is-active', k === n)); bars.forEach((b, k) => b.classList.toggle('on', k <= n)); };
    f.addEventListener('click', e => {
      const o = e.target.closest('.finder__opt'); if (!o || o.tagName === 'A') return;
      e.preventDefault();
      if (o.dataset.tag) tags[i] = o.dataset.tag;
      i++;
      if (i < steps.length - 1) { show(i); return; }
      const base = f.dataset.collection || '/collections/all';
      const clean = tags.filter(Boolean).map(t => encodeURIComponent(t.toLowerCase().trim().replace(/\s+/g, '-')));
      const link = $('[data-finder-result]', f);
      link.href = base + (clean.length ? '/' + clean.join('+') : '');
      show(steps.length - 1);
    });
    $$('[data-finder-reset]', f).forEach(r => r.addEventListener('click', e => { e.preventDefault(); i = 0; tags.length = 0; show(0); }));
  });
})();
